import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Form, FormSpy } from 'react-final-form';
import { Form as AntdForm, Button, Spin, Select } from 'antd';
import moment from 'moment';
import { assoc, pick, prop } from 'ramda';
import createDecorator from 'final-form-focus';
import * as yup from 'yup';

import { stateMessages, errorMessages } from '../constants/opd';
import { COUNTRIES, KZ } from '../constants/countries';
import fields from './fields/';
import LanguageContext from './LanguageContext';

const titles = {
    [KZ]: 'titleKZ',
};

const focusOnErrors = createDecorator();
const { Option } = Select;

const validationSchema = yup.object().shape({
    lastName: yup.string().required(),
    firstName: yup.string().required(),
    middleName: yup.string().required(),
    emailPersonal: yup.string().email().required(),
    phone: yup.string().required(),
    birthdate: yup.string().required(),
    address: yup.string().required(),
    SoglasieOPD: yup.bool().oneOf([true]).required(),
    SoglasieMSG: yup.bool().required(),
});

class OPDForm extends Component {
    static propTypes = {
        getUserLink: PropTypes.object.isRequired,
        metaPost: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired,
        changeLanguage: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
        authKey: PropTypes.string,
        country: PropTypes.string,
        language: PropTypes.string,
        languages: PropTypes.array,
        isTestForm: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            opdDate: moment().format('DD.MM.YYYY'),
        };
    }

    renderForm = formProps => {
        const { handleSubmit, submitFailed } = formProps;
        const { getRef, metaPost, country, language, openCancelModal } = this.props;
        const Fields = fields[country] && fields[country][language] ? fields[country][language]: null;

        return (
            <AntdForm onFinish={handleSubmit} noValidate>
                <FormSpy>
                    {({ values }) => getRef(formProps, values) || null}
                </FormSpy>
                { Fields && <Fields t={this.props.t} /> }
                <div className="container">
                    <div className="controls">
                        <Button
                            type='primary'
                            className={submitFailed && 'error'}
                            loading={metaPost.pending}
                            htmlType='submit'
                        >
                            {this.props.t('submit')}
                        </Button>
                        {/* <Button
                            className='cancel-button'
                            onClick={openCancelModal}>
                            {this.props.t('reject')}
                        </Button> */}
                    </div>
                    <div className="opd-date">
                        {this.props.t('approveDate')}: {this.state.opdDate}
                    </div>
                </div>
            </AntdForm>
        );
    }

    validate = values => {
        try {
            validationSchema.validateSync(values, { abortEarly: false });
        } catch (e) {
            return e.inner.reduce((errors, error) => assoc(error.path, error.message, errors), {});
        }
    }

    onSubmit = values => {
        this.setState({
            opdDate: moment().format('DD.MM.YYYY'),
         });

        this.props.onSubmit(values);
    }

    render() {
        const { country, t } = this.props;
        const { meta: { success, error, pending }, data } = this.props.getUserLink;
        const opdInfo = data || {};

        if (pending) {
            return <Spin />;
        }

        return (success || this.props.isTestForm) ? (
            <Fragment>
                <div className="title-box">
                    <div className="container">
                        <h1>{this.props.t(titles[country] || 'title')}</h1>
                        <div className='hide-in-doc' style={{ marginBottom: 5 }}>{ t('languages') }</div>
                        <Select className='lang-select hide-in-doc' value={this.props.language} onChange={this.props.changeLanguage} style={{ width: 120 }}>
                            { this.props.languages && this.props.languages.map(lang => (
                                <Option key={lang} value={lang}>
                                    <span className={`lang ${lang}`} />{`${lang}`.toUpperCase()}
                                </Option>
                            ))}
                        </Select>
                        <div className='hide-in-doc' style={{ marginTop: 20, marginBottom: 5 }}>{ t('countries.label') }</div>
                        <Select
                            className='country-select'
                            value={this.props.opdCountryCode}
                            onChange={this.props.setCountry}
                            style={{ width: 170 }}>
                            { COUNTRIES.map(({ value, code }) => (
                                <Option key={`country-${value}`} value={code}>
                                    <span className={`lang ${value}`} />{ t(`countries.${value}`) }
                                </Option>
                            ))}
                        </Select>
                    </div>
                    <span className="img" />
                </div>
                <LanguageContext.Provider value={this.props.language}>
                    <Form
                        subscription={{ submitting: true, valid: true, pristine: true, submitFailed: true }}
                        initialValues={pick(['email'], opdInfo)}
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={this.renderForm}
                        decorators={[ focusOnErrors ]}
                    />
                </LanguageContext.Provider>
            </Fragment>
        ) : error ? (
            <Fragment>
                <div className="error-wrap">
                    <h2>
                        { stateMessages[opdInfo.state] || errorMessages[prop('code', error)] || (
                            <div className='button' onClick={() => window.location.reload()}>{errorMessages.error}</div>
                        )}
                    </h2>
                </div>
                { error && error.session }
            </Fragment>
        ) : null;
    }
}

export default OPDForm;
